import { combineReducers } from 'redux';
import application from './redux/reducers/application';

const reducer = combineReducers({
  application
});

export default reducer;